export const EDLY_GO = 'https://edly.io/edly-go/';
export const EDLY_GO_PLAYSTORE = 'https://play.google.com/store/apps/details?id=io.edly.mobile';
export const EDLY_GO_APPYSTORE = 'https://apps.apple.com/us/app/edly-go/id1545124907';
